if (typeof PressCarousel === 'undefined') {
    class PressCarousel extends HTMLElement {
        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            const autoplayEnabled = this.dataset.autoplay === 'true';
            const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 5000;

            const autoplayConfig = autoplayEnabled ? {
                delay: autoplayDelay,
                disableOnInteraction: true,
                pauseOnMouseEnter: false
            } : false;            

            whenReady('Swiper', () => {
                try {
                    this.swiper = new Swiper(swiperContainer, {
                        loop: true,
                        a11y: true,
                        autoplay: autoplayConfig,
                        slidesPerView: 1,
                        spaceBetween: 10, 
                        effect: 'fade',
                        fadeEffect: { crossFade: true },                        
                        mousewheel: {
                            forceToAxis: true,
                            thresholdDelta: 12
                        },
                        navigation: {
                            nextEl: this.querySelector('.swiper-next'),
                            prevEl: this.querySelector('.swiper-prev'),
                        },
                        modules: [Swiper.A11y, Swiper.Navigation, Swiper.Mousewheel, Swiper.EffectFade, Swiper.Autoplay]
                    });

                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

    }

    if (!window.customElements.get('press-carousel')) {
        window.customElements.define('press-carousel', PressCarousel);
    }
}